import { GetHomePageDataResponseSchema, type GetHomePageDataResponse } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomBaseUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useHomePage(options?: CustomBaseUseQueryOptions<GetHomePageDataResponse>) {
  const homePageQuery = useQuery(['home-page'], async () => {
    const api = getPrivateApi();
    const homePageData = await api.getHomePageData();

    return GetHomePageDataResponseSchema.parse(homePageData);
  }, { suspense: true, ...options });
  validateNotEmptyObject(homePageQuery.data, 'homePageQuery.data');

  return homePageQuery;
}